import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderDownload = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M18 21.457L18 22L18 14", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M14.5 18.5L18 22L21.5 18.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13.4141 5H23V13H21V7H12.5859L9.58594 4H3V19H10.7539L12.7539 21H1V2H10.4141L13.4141 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFolderDownload.js.map